import { NgModule } from '@angular/core'
import { StoreModule } from '@ngrx/store'
import { EffectsModule } from '@ngrx/effects'
import { evisitorReducer } from './evisitor.reducer'
import { EVisitorEffects } from './evisitor.effects'

@NgModule({
  imports: [StoreModule.forFeature('evisitor', evisitorReducer), EffectsModule.forFeature([EVisitorEffects])],
})
export class EVisitorStoreModule {}
